elabs.PrimaryNavigationMenu = class {
  constructor() {
    if (elabs.PrimaryNavigationMenu.instance) {
      // This is a singleton, do not allow more than once instance
      return elabs.PrimaryNavigationMenu.instance;
    }
    elabs.PrimaryNavigationMenu.instance = this;
    this.initialise();
  }

  initialise = () => {
    const primaryNavigationButton = document.querySelector('.el-header__menu-link');
    primaryNavigationButton?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      elabs.overlayMenuService.showMenu({ templateId: 'el-primary-navigation-menu' }, 'left');
      this.addEventListeners();
    });
  };

  addEventListeners = () => {
    const menuBody = document.querySelector('.el-overlay-menu__body');
    menuBody.addEventListener('click', () => {
      // they clicked outside the menu items, so hide any submenu
      const submenuContainer = document.querySelector('.el-primary-navigation-menu__submenu-container');
      document
        .querySelector('.el-primary-navigation-menu__item--active')
        ?.classList.remove('el-primary-navigation-menu__item--active');
      submenuContainer.innerHTML = '';
      document.querySelector('.el-overlay-menu').classList.remove('el-overlay-menu--wide');
    });

    const topLevelMenu = document.querySelector('.el-primary-navigation-menu__list');
    topLevelMenu.addEventListener('click', (event) => {
      const menuItem = event.target.closest('.el-primary-navigation-menu__item');
      if (!menuItem) {
        return;
      }

      if (menuItem.classList.contains('el-primary-navigation-menu__item--active')) {
        // let the main menu item go to the Shop All link
        return;
      }

      // remove the previous selection
      document
        .querySelector('.el-primary-navigation-menu__item--active')
        ?.classList.remove('el-primary-navigation-menu__item--active');

      menuItem.classList.add('el-primary-navigation-menu__item--active');

      const submenu = menuItem.querySelector('.el-primary-navigation-menu__submenu');
      const submenuContainer = document.querySelector('.el-primary-navigation-menu__submenu-container');
      const submenuItems = submenu ? submenu.querySelectorAll('.el-primary-navigation-menu__submenu-item') : [];
      if (submenuItems.length === 0 || !submenuContainer) {
        // there is no submenu, allow the click to propagate
        submenuContainer.innerHTML = '';
        document.querySelector('.el-overlay-menu').classList.remove('el-overlay-menu--wide');
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (submenu) {
        submenuContainer.innerHTML = submenu.innerHTML;
        requestAnimationFrame(() => {
          document.querySelector('.el-overlay-menu').classList.add('el-overlay-menu--wide');
        });
      }
    });
  };
};

elabs.onJavascriptReady(() => {
  elabs.primaryNavigationMenu = new elabs.PrimaryNavigationMenu();
});
